import {useQuery} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {CustomReportDataType} from "../types/CustomReportDataType";
import {CustomReportColumnType} from "../types/CustomReportColumnType";

export const useGetCustomReportColumns = (companyId: number | undefined, reportType: string | undefined, layoutName: string) => {
    const {data, isLoading, refetch} = useQuery({
        queryKey: ['get-custom-report-columns'],
        queryFn: async () => await apiClient.get('system-reports/custom-report-columns', {
            params: {
                reportType,
                layoutName,
            }
        }) as CustomReportColumnType[],
        enabled: false,
        cacheTime: 0
    });

    return {
        data,
        isLoading,
        refetch
    };
};
